export default {
  methods: {
    refetchQueries() {
      for (const key of Object.keys(this.$apollo.queries)) {
        this.$apollo.queries[key].refetch();
      }
    },
  },
  mounted() {
    this.refetchQueries();

    this.$broadcast().$on('refresh-apollo', () => {
      this.refetchQueries();
    });
  },
};
